import isNumber from './is-number';

var isEven = function (num) {
  return isNumber(num) && num % 2 === 0;
};

export default isEven;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/is-even.js
// module id = 61
// module chunks = 0